import { fetchData } from '@/services/api/client'
import { CurrentConditionsResponse } from '@/services/api/bff/weather/dtos/CurrentConditions.dto'
import { DayboxesResponse } from '@/services/api/bff/weather/dtos/Dayboxes.dto'

export const fetchCurrentConditions = async (
  geohash: string,
  options?: RequestInit,
): Promise<CurrentConditionsResponse> => {
  const url = `/api/bff/current-conditions?filter[geohash]=${geohash}`
  return fetchData(url, options)
}

export const fetchDayboxes = async (
  geohash: string,
  options?: RequestInit,
): Promise<DayboxesResponse> => {
  const url = `/api/bff/dayboxes?filter[geohash]=${geohash}`
  return fetchData(url, options)
}
